import { RES_TYPES, useFetch } from "@chainless/chainless-react";
import { useEffect, useState, useMemo, useCallback } from "react";
import { DeleteVGMItem } from "./DeleteVGMItem";
import { Calendar } from "primereact/calendar";
import "./vgm.css";

export const AtvDagen = ({ atvdagen, refresh }) => {
  const [selectedDates, setSelectedDates] = useState([]);
  const {
    res: postResRes,
    fetchData,
    error: postErr,
  } = useFetch(`/api/atvdagen`, {
    method: "POST",
    resType: RES_TYPES.text,
    lateFetch: true,
  });

  const dateToTimestamp = useCallback((date) => {
    if (!date) return null;
    return Math.floor(
      new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() /
        1000,
    );
  }, []);

  // Check of datum al bestaat in atvdagen
  const isDuplicateDate = useCallback(
    (date) => atvdagen.some((item) => item.timestamp === dateToTimestamp(date)),
    [atvdagen, dateToTimestamp],
  );

  const handleDateSelection = useCallback(
    (dates) => {
      const uniqueDates = (dates || []).filter((date) => {
        if (isDuplicateDate(date)) {
          alert("Deze datum is al geselecteerd!");
          return false;
        }
        return true;
      });
      setSelectedDates(uniqueDates);
    },
    [isDuplicateDate],
  );

  const selectedDateTimestamps = useMemo(
    () =>
      (selectedDates || [])
        .map(dateToTimestamp)
        .filter((timestamp) => Number.isFinite(timestamp)),
    [selectedDates, dateToTimestamp],
  );

  const postAtvdagen = useCallback(() => {
    if (selectedDateTimestamps.length > 0) {
      fetchData(
        JSON.stringify(
          selectedDateTimestamps.map((timestamp) => ({ timestamp })),
        ),
      );
    }
  }, [selectedDateTimestamps, fetchData]);

  const formatAtvDag = useCallback((item) => {
    if (item) {
      const timestamp = item.timestamp;
      return new Date(timestamp * 1000).toLocaleDateString("nl-NL");
    }
  }, []);

  useEffect(() => {
    if (postResRes && postResRes.ok) {
      setSelectedDates([]);
      refresh();
    } else if (postErr) {
      alert("Fout bij het opslaan van ATV dagen", postErr);
    }
  }, [postResRes, postErr, refresh]);

  return (
    <div className="atv-container">
      <h2>ATV Dagen</h2>
      <div className="atv-lijst-grid">
        {atvdagen && atvdagen.map((item) => (
          <div className="atv-lijst-block" key={item.id}>
            <div className="atv-lijst-row">
              <span className="atv-lijst-date">{formatAtvDag(item)}</span>
              <DeleteVGMItem
                url={`/api/atvdagen/${item.id}`}
                refresh={refresh}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="atv-calendar">
        <Calendar
          value={selectedDates}
          onChange={(e) => handleDateSelection(e.value)}
          selectionMode="multiple"
          inline
        />
        <button onClick={postAtvdagen}>Toevoegen</button>
      </div>
    </div>
  );
};
